import(/* webpackMode: "eager" */ "/home/meywd/AlUmmahNow/apps/web/src/app/[locale]/page.tsx");
